module.exports = __webpack_public_path__ + "img/1526029030.a3675bcb.jpg";